<div class="body">
	<div class="content-404">
		<h1>OOPS!</h1>
		<div class="content-404_message">
			<h2>
				404 - THE PAGE CAN'T BE FOUND
			</h2>
			<a href="https://poviard.com/">
				GO TO HOMEPAGE
			</a>
		</div>
	</div>
</div>
<style lang="scss">
.body{
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
}

.body .content-404 h1{
	font-size: 15em;
	font-weight: 100;
	line-height: 0.5;
	color: var(--blue-dark);
}

.body .content-404 .content-404_message{
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.body .content-404 .content-404_message h2{
	background: var(--white);
	display: inline-block;
	padding: 10px 25px;
}

.body .content-404 .content-404_message a{
	background: var(--blue-dark);
	color: var(--white);
	padding: 10px 25px;
	text-decoration: none;
	display: inline-block;
}
</style>